import React from 'react';

/* Pose chaque ligne (nom + jours) en position absolue avec le même « top » calculé des deux côtés :
   la colonne de noms et la grille des jours arrondissent les sous-pixels différemment, un calcul
   explicite évite toute dérive d'alignement. */
export const positionRows = (rows, totalWidth) => {
  let y = 0;
  const positioned = rows.map((r) => {
    const top = y;
    y += r.rowH;
    const place = (el, extra) =>
      React.cloneElement(el, {
        style: { ...el.props.style, position: 'absolute', top, left: 0, ...extra, height: r.rowH },
      });
    return {
      name: place(r.name, { right: 0 }),
      body: place(r.body, { width: totalWidth }),
    };
  });
  return {
    names: positioned.map((x) => x.name),
    bodies: positioned.map((x) => x.body),
    rowsTotalH: y,
  };
};
